module.exports = __webpack_public_path__ + "static/media/kumo-okane.829f06bb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/kumo-okane.svg
 ** module id = 1330
 ** module chunks = 0
 **/